module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-auto-template/src/templates/drag-to-upload.html -->\n<div class="circle">\n  <span class="va">'+
((__t=( icons.faCloudUploadAlt ))==null?'':__t)+
'</span>\n  <span class="text" data-i18n="i18n.dragToUpload">i18n.dragToUpload</span>\n</div>\n';
}
return __p;
};
